import * as Sentry from '@sentry/nuxt'
import { useRuntimeConfig } from '#imports'

const {
  public: { sentry },
} = useRuntimeConfig()

// we only want to run on staging
if (!import.meta.dev) {
  Sentry.init({
    dsn: sentry.dsn,
    environment: sentry.environment,
    integrations: [Sentry.replayIntegration()],
    // Tracing
    // We recommend adjusting this value in production, or using a tracesSampler for finer control.
    tracesSampleRate: import.meta.dev ? 0 : 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}
